import React, { Component } from 'react';

import TopSummary from './TopSummary';
import MainMenu from './MainMenu';

import {observer} from 'mobx-react';

class App extends Component {
  render() {
    return (
      <div className="container_16">
        <MainMenu />
        <div className="grid_16">
          <div id="logo">Turner Roofing</div>
          <TopSummary testimonials={this.props.testimonials}/>
        </div>
        <div className='topbox'>
          Turner Roofing are a York based father and son roofing company with over 50 years combined experience in all aspects of roofing and roofing repair work.
        </div>
        <div id='pageholder'>
          <br />
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default observer(['testimonials'])(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/